import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class FooterOneService {

  constructor(private _http: HttpClient) { }

    subscribeemail(data) {
        return this._http.post(environment.api_url+'subscribe',data);
    }

    getcategories(data) {
        return this._http.post(environment.api_url+'home/categories',data);
    }
}
